// Coresponding with Django Lead model
export const LEAD_STATUS_NEW = 1;
export const LEAD_STATUS_ATTEMPTING_CONTACT = 2;
export const LEAD_STATUS_IN_DISCUSSION = 3;
export const LEAD_STATUS_APPLICATION_IN_PROGRESS = 4;
export const LEAD_STATUS_WON = 5;
export const LEAD_STATUS_LOST = 6;
export const LEAD_STATUS_ARCHIVED = 7;

const LEAD_STATUS_NEW_OPTION = {
  label: 'New',
  value: LEAD_STATUS_NEW.toString(),
};

const LEAD_STATUS_ATTEMPTING_CONTACT_OPTION = {
  label: 'Attempting Contact',
  value: LEAD_STATUS_ATTEMPTING_CONTACT.toString(),
};
const LEAD_STATUS_IN_DISCUSSION_OPTION = {
  label: 'In Discussion',
  value: LEAD_STATUS_IN_DISCUSSION.toString(),
};
const LEAD_STATUS_APPLICATION_IN_PROGRESS_OPTION = {
  label: 'Application In Progress',
  value: LEAD_STATUS_APPLICATION_IN_PROGRESS.toString(),
};
const LEAD_STATUS_WON_OPTION = {
  label: 'Won',
  value: LEAD_STATUS_WON.toString(),
};
const LEAD_STATUS_LOST_OPTION = {
  label: 'Lost',
  value: LEAD_STATUS_LOST.toString(),
};
const LEAD_STATUS_ARCHIVED_OPTION = {
  label: 'Deleted',
  value: LEAD_STATUS_ARCHIVED.toString(),
};

export const LEAD_EDIT_STATUSES = [
  LEAD_STATUS_NEW_OPTION,
  LEAD_STATUS_ATTEMPTING_CONTACT_OPTION,
  LEAD_STATUS_IN_DISCUSSION_OPTION,
  LEAD_STATUS_APPLICATION_IN_PROGRESS_OPTION,
  LEAD_STATUS_WON_OPTION,
  LEAD_STATUS_LOST_OPTION,
];

export const LEAD_ALL_STATUSES = [
  LEAD_STATUS_NEW_OPTION,
  LEAD_STATUS_ATTEMPTING_CONTACT_OPTION,
  LEAD_STATUS_IN_DISCUSSION_OPTION,
  LEAD_STATUS_APPLICATION_IN_PROGRESS_OPTION,
  LEAD_STATUS_WON_OPTION,
  LEAD_STATUS_LOST_OPTION,
  LEAD_STATUS_ARCHIVED_OPTION,
];

export const LEAD_ACTIVE_LIST_STATUSES = [
  LEAD_STATUS_NEW_OPTION,
  LEAD_STATUS_ATTEMPTING_CONTACT_OPTION,
  LEAD_STATUS_IN_DISCUSSION_OPTION,
  LEAD_STATUS_APPLICATION_IN_PROGRESS_OPTION,
  LEAD_STATUS_WON_OPTION,
  LEAD_STATUS_LOST_OPTION,
];

// Coresponding with Django Lead model
export const LOST_REASON_UNABLE_TO_CONTACT = 1;
export const LOST_REASON_UNDERWRITING = 2;
export const LOST_REASON_MORAL_HAZARD = 3;
export const LOST_REASON_PRICE = 4;

export const LOST_REASONS = [
  {
    label: 'Unable to Contact',
    value: LOST_REASON_UNABLE_TO_CONTACT.toString(),
  },
  { label: 'Underwriting', value: LOST_REASON_UNDERWRITING.toString() },
  { label: 'Moral Hazard', value: LOST_REASON_MORAL_HAZARD.toString() },
  { label: 'Price', value: LOST_REASON_PRICE.toString() },
];
